<!-- On vérifie que le rootForm existe avant de créer les champs liés -->
<div *ngIf="rootForm && lieuxAsso && ! (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxAsso">
      <div class="col" [formGroup]="rootForm">
        <div>
        <mat-accordion class=" col-12">
          <div *ngFor="let item of lieuxAsso.controls; let i = index">
            <mat-expansion-panel [expanded]="step === i" (opened)="setStep(i)">
              <mat-expansion-panel-header>
                <mat-panel-description>
                  <mat-icon>account_circle</mat-icon>&#xA0;
                  <span [ngClass]="{'onglet-invalide': lieuxAsso.controls[i].invalid}">
                    Informations sur le local {{ i + 1 }}
                  </span>
                  <button *ngIf="(modeRenduService.enModeSaisie$ | async)" (click)="supprimerLieuxAsso(i)" class="btn-danger btn-sm ml-auto"
                    title="Supprimer le local">
                    <i class="material-icons md-18">delete</i>
                  </button>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="form-row">
                  <div class="col-md-8">
                    <!--<bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxAsso.controls[i]" 
                        nbChoixVisiblePossible="5" label="aaLieuAssoCodCom" nomNomenclature="commune">
                    </bis-filtered-select-input-keypad>-->
                    <bis-commune-input-keypad [rootForm]="lieuxAsso.controls[i]" [preId]="i" nbChoixVisiblePossible=10
                          label="aaLieuAssoCodCom" nomNomenclature="commune">
                    </bis-commune-input-keypad>
                  </div>
                  <div class="col-md-4">
                    <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxAsso.controls[i]" label="aaLieuAssoQp" 
                              infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" nomNomenclature="ouiNonNsp">
                    </bis-filtered-select-input-keypad>
                  </div>
              </div>
              <div class="form-row">
                  <div class="col-md-1"></div>
                  <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxAsso.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                    label="aaLieuAssoNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA60Asso']">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxAsso.controls[i]" colorErreur="danger"
                          labelErreur="ctrlA60Asso">
                    </bis-affiche-erreurs-croisees>
                  </div>
              </div>
              <div class="form-row">
                  <div class="col-md-1"></div>
                  <div class="col-md-10">
                      <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxAsso.controls[i]" classeColLabel="col-8" 
                      classeColInput="col-2" classeSupplInput="text-right" label="aaLieuAssoNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA61Asso']"
                      infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                      </bis-integer-inline-input-keypad>
                      <bis-affiche-erreurs-croisees [rootForm]="lieuxAsso.controls[i]" colorErreur="danger"
                        labelErreur="ctrlA61Asso">
                      </bis-affiche-erreurs-croisees>
                      <bis-affiche-alertes [labelAlerte]="'alertA39Asso_' + i"></bis-affiche-alertes>
                  </div>
              </div>
              <div class="form-row">
                  <div class="col-md-1"></div>
                  <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxAsso.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                    label="aaLieuAssoNbVict" [max]="99999" infoBulle="(physiques et morales)">
                    </bis-integer-inline-input-keypad>
                  </div>
            </div>
          </mat-expansion-panel>
          </div>
          </mat-accordion>

          <button *ngIf="modeRenduService.enModeSaisie$ | async" class="mt-4 ml-n1 btn btn-info"
          (click)="ajouterLieuxAsso()">Ajouter un local association</button>

          <div class="form-row mt-4">
              <div class="col-md-6">
                <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuAssoNb" [max]="99" enLectureSeule="true"
                  classeColLabel="col-6" classeColInput="col-4"      
                  infoBulle="Cette zone est calculée automatiquement à partir du nombre de local ajouté(s)">
                </bis-integer-inline-input>
            </div>
            <div class="col-md-6">
                <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuAssoNbPermTot" [max]="9999" enLectureSeule="true"
                  classeColLabel="col-6" classeColInput="col-4">
                </bis-integer-inline-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-10">
                <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuAssoNbPermEtpTot" [max]="99999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
                </bis-integer-inline-input>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-10">
                <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuAssoNbVictTot" [max]="999999" 
                    enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
                </bis-integer-inline-input>
            </div>
          </div>  
        </div>
      </div>
    </div>
</div>    


<div *ngIf="rootForm && lieuxAsso && (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxAsso">
    <div class="col" [formGroup]="rootForm">
      <div>
        <div *ngFor="let item of lieuxAsso.controls; let i = index">
            <div class="form-row">
                <div class="col-md-8">
                  <!--<bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxAsso.controls[i]" 
                      nbChoixVisiblePossible="5" label="aaLieuAssoCodCom" nomNomenclature="commune">
                  </bis-filtered-select-input-keypad>-->
                  <bis-commune-input-keypad [rootForm]="lieuxAsso.controls[i]" [preId]="i" nbChoixVisiblePossible=10
                        label="aaLieuAssoCodCom" nomNomenclature="commune">
                  </bis-commune-input-keypad>
                </div>
                <div class="col-md-4">
                  <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxAsso.controls[i]" label="aaLieuAssoQp" 
                            infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" nomNomenclature="ouiNonNsp">
                  </bis-filtered-select-input-keypad>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                  <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxAsso.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                  label="aaLieuAssoNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA60Asso']">
                  </bis-integer-inline-input-keypad>
                  <bis-affiche-erreurs-croisees [rootForm]="lieuxAsso.controls[i]" colorErreur="danger"
                        labelErreur="ctrlA60Asso">
                  </bis-affiche-erreurs-croisees>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxAsso.controls[i]" classeColLabel="col-8" 
                    classeColInput="col-2" classeSupplInput="text-right" label="aaLieuAssoNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA61Asso']"
                    infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxAsso.controls[i]" colorErreur="danger"
                      labelErreur="ctrlA61Asso">
                    </bis-affiche-erreurs-croisees>
                    <bis-affiche-alertes [labelAlerte]="'alertA39Asso_' + i"></bis-affiche-alertes>
                </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                  <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxAsso.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                  label="aaLieuAssoNbVict" [max]="99999" infoBulle="(physiques et morales)">
                  </bis-integer-inline-input-keypad>
                </div>
          </div>
        </div>
        <div class="form-row mt-4">
            <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuAssoNb" [max]="99" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4"      
                infoBulle="Cette zone est calculée automatiquement à partir du nombre de local ajouté(s)">
              </bis-integer-inline-input>
          </div>
          <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuAssoNbPermTot" [max]="9999" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuAssoNbPermEtpTot" [max]="99999" 
                enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuAssoNbVictTot" [max]="999999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div>